const Students = () => {
  return (
    <svg
      width='22'
      height='16'
      viewBox='0 0 22 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M15.6699 9.12988C17.0399 10.0599 17.9999 11.3199 17.9999 12.9999V15.9999H21.9999V12.9999C21.9999 10.8199 18.4299 9.52988 15.6699 9.12988Z'
        fill='#5A5955'
      />
      <path
        d='M13.9999 8C16.2099 8 17.9999 6.21 17.9999 4C17.9999 1.79 16.2099 0 13.9999 0C13.5299 0 13.0899 0.0999998 12.6699 0.24C13.4999 1.27 13.9999 2.58 13.9999 4C13.9999 5.42 13.4999 6.73 12.6699 7.76C13.0899 7.9 13.5299 8 13.9999 8Z'
        fill='#5A5955'
      />
      <path
        d='M8 8C10.21 8 12 6.21 12 4C12 1.79 10.21 0 8 0C5.79 0 4 1.79 4 4C4 6.21 5.79 8 8 8ZM8 2C9.1 2 10 2.9 10 4C10 5.1 9.1 6 8 6C6.9 6 6 5.1 6 4C6 2.9 6.9 2 8 2Z'
        fill='#5A5955'
      />
      <path
        d='M8 9C5.33 9 0 10.34 0 13V16H16V13C16 10.34 10.67 9 8 9ZM14 14H2V13.01C2.2 12.29 5.3 11 8 11C10.7 11 13.8 12.29 14 13V14Z'
        fill='#5A5955'
      />
    </svg>
  );
};

export default Students;
